import { z } from 'zod';

const DiscountSchema = z.object({
  code: z.string(),
  name: z.string(),
  amount: z.number().min(0),
  amountUnits: z.enum(['percent', 'dollars']),
  start: z.string(),
  end: z.string(),
  // Subscription billing only (once vs forever renewals). Irrelevant for plugins.
  duration: z.enum(['once', 'forever']).optional(),
  // Legacy ACCOUNT-533 flag; no longer enforced.
  usedOnce: z.boolean().optional(),
  minimum: z.number().min(0).optional(),
  minimumUnits: z.enum(['copies', 'dollars']).optional(),
  // 'item' = full $/% per eligible copy; 'order' = once against the order total.
  copyLimitScope: z.enum(['item', 'order']).optional(),
  // Global redemption pool (how many checkouts may use this code). Blank = unlimited.
  quantityAvailable: z.number().optional(),
  // Checkouts that have consumed a pool use.
  quantityUsed: z.number().optional(),
  productIds: z.string().array(),
  _id: z.string(),
});

export type Discount = z.infer<typeof DiscountSchema>;

// List all discounts
export const ListDiscountsResponseSchema = DiscountSchema.array();

export type ListDiscountsResponse = z.infer<typeof ListDiscountsResponseSchema>;
export type ListDiscountsRequest = void;

// Get one discount
export const GetDiscountResponseSchema = DiscountSchema;
export type GetDiscountResponse = z.infer<typeof GetDiscountResponseSchema>;
export type GetDiscountRequest = string;

// Create a discount
export const CreateDiscountResponseSchema = DiscountSchema;
export type CreateDiscountResponse = z.infer<
  typeof CreateDiscountResponseSchema
>;
export type CreateDiscountRequest = Omit<Discount, '_id'>;

// Update a discount
export const UpdateDiscountResponseSchema = DiscountSchema;
export type UpdateDiscountResponse = z.infer<
  typeof UpdateDiscountResponseSchema
>;
export type UpdateDiscountRequest = Discount;

export const DeleteDiscountResponseSchema = z.object({
  message: z.string(),
});
export type DeleteDiscountResponse = z.infer<
  typeof DeleteDiscountResponseSchema
>;
export type DeleteDiscountRequest = string;
